module.exports = __webpack_public_path__ + "img/zy.c551487.png";